import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { client } from 'src/utils/api';
import en from 'src/messages/en.json';
import { setError } from 'src/redux/features/common/commonSlice';

export const fetchAllPos: any = createAsyncThunk(
  'managePo/fetchAllPos',
  async (
    payload: {
      PoNumber?: string;
      VendorName?: string;
      StartDate?: string;
      EndDate?: string;
      PageNumber?: number;
      PageSize?: number;
      SortField?: string;
      SortDirection?: string;
    },
    { signal, rejectWithValue, dispatch },
  ) => {
    try {
      const query = new URLSearchParams(payload as any).toString();
      const response = await client.get(`PO/purchaseOrders?${query}`, {
        signal,
      });

      return response.data;
    } catch (err: any) {
      if (err === en.Common.Error.signalAborted) {
        console.log(err);

        return;
        // aborted → just ignore
      }
      dispatch(setError(en.Common.Error.fetchData));

      return rejectWithValue(err.message);
    }
  },
);
export const assignResourceToPoData: any = createAsyncThunk(
  'managePo/assignResourceToPoData',
  async (
    { purchaseOrder, itLeaderEmail, payload }: any,
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await client.post(
        `PO/save/${purchaseOrder}?itLeaderEmail=${itLeaderEmail}`,
        payload,
      );

      return response.data;
    } catch (err) {
      dispatch(setError(err.message || en.Common.Error.saveChanges));

      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
export const searchAssignedDateRangeByEmail: any = createAsyncThunk(
  'managePo/searchAssignedDateRangeByEmail',
  async ({ email }: any, { rejectWithValue }) => {
    try {
      const response = await client.get(`/PO/resource/${email}`);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
export const searchPoDetailsByPoNumber: any = createAsyncThunk(
  'managePo/searchPoDetailsByPoNumber',
  async ({ purchaseOrder }: any, { rejectWithValue }) => {
    try {
      const response = await client.get(`PO/purchaseOrder/${purchaseOrder}`);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
export const updateAndDeleteResourceSplitDate: any = createAsyncThunk(
  'managePo/updateAndDeleteResourceSplitDate',
  async ({ purchaseOrder, id, payload }: any, { rejectWithValue }) => {
    try {
      const response = await client.post(
        `PO/save/${purchaseOrder}/${id}`,
        payload,
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
